import { useState } from 'react';
import Loading from '../components/Loading';
import './AddEventPopUp.css';

function AddEventPopUp({ chosenDay, setPopUpWindow, refreshCalendarEvents }) {
    const [statusMessage, setStatusMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [event, setEvent] = useState(undefined);

    async function sendEvent(form) {
      setIsLoading(true);
      try {
        const jwtToken = sessionStorage.getItem("jwtToken");
        const request = {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
            'x-api-key': process.env.REACT_APP_API_KEY
          },
          body: JSON.stringify({
            year: chosenDay.getFullYear(),
            month: chosenDay.getMonth(),
            day: chosenDay.getDate(),
            timezoneOffset: chosenDay.getTimezoneOffset(),
            ...form
          })
        }
        const result = await fetch(`${process.env.REACT_APP_API_URL}/addEvent`, request);
        const response = await result.json();
        setStatusMessage(response.message);
        if (result.status === 201) {
          refreshCalendarEvents();
          setTimeout(() => {
            setPopUpWindow(false)
          }, 1000);
        }
      } catch(e) {
        setStatusMessage("An error has occured.");
      };
      setIsLoading(false);
      }

    function handleSubmit(e) {
        e.preventDefault();
        const data = new FormData(e.target);
        const formObject = Object.fromEntries(data.entries());
        sendEvent(formObject);
    }
  
  function onChangeEventSelector(e) {
    const eventSelectorType = e.target.value;
    setEvent(eventSelectorType);
  };

  return (
    <form className="add-event--popup-window-body" onSubmit={handleSubmit}>
        <input name="time" type="time" id="time--input" min="08:00" max="20:00" step="900" required />
        <select name="type" id="event--type" onChange={onChangeEventSelector}>
            <option value="individual-class">Individual Class</option>
            <option value="group-class">Group Class (max: 4 students)</option>
            <option value="coaching-session">Coaching</option>
            <option value="custom-event">Custom Event</option>
        </select>
        <input name="topic" type="text" id="event--topic" placeholder="Topic" maxLength={50} />
        {event === "custom-event" && <input name="duration" type="number" id="event--duration" placeholder="Duration (in minutes)" min={30} max={180} step={5} required />}
        {event === "custom-event" && <input name="maxParticipants" type="number" id="event--participants" placeholder="Max participants" min={1} max={40} required />}
        {event === "custom-event" && <input name="price" type="number" id="event--price" placeholder="Price (per student)" min={11000} max={100000} step={1000} required />}
        {event === "custom-event" && <textarea name="description" rows={3} className="event--description" placeholder="Description" maxLength={500} />}
        <div className="add-event--status">{ isLoading ? <Loading /> : statusMessage }</div>
        <button type="submit" className="add-event--submit-btn">Confirm</button>
    </form>
  )
}

export default AddEventPopUp;